/** Step 3: 地図プレビューが実行可能か（ルート用 FIT 必須・処理中は不可） */
export function canPreviewFitOnMap(opts: {
  busy: string | null;
  fitRouteFile: File | null;
}): boolean {
  return opts.busy == null && opts.fitRouteFile != null;
}

/** Step 3: エクスポート時のファイル名（ルート用で読み込んだ FIT のベース名を使う） */
export function buildMynazcaExportFitFileName(routeFileName: string | null | undefined): string {
  const raw = routeFileName?.trim() ?? '';
  const base = raw.replace(/\.fit$/i, '') || 'route';
  return `MyNazca_${base}.fit`;
}
